<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                src="@/assets/images/pages/login.png"
                alt="login"
                class="mx-auto w-1/2"
              />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div
                class="px-8 pt-8 login-tabs-container flex flex-col justify-center"
              >
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Login</h4>
                  <p>Silakan login dengan username</p>
                </div>
                <vs-alert color="danger" :active="isWrong">
                  Username atau password salah. Silakan coba kembali.
                </vs-alert>
                <div class="w-full">
                  <div class="vx-row mb-6">
                    <div class="vx-col w-full">
                      <vs-input
                        class="w-full"
                        type="user"
                        label="Username"
                        v-model="input.username"
                        v-on:keyup.enter="handleSubmit()"
                      />
                    </div>
                  </div>
                  <div class="vx-row mb-6">
                    <div class="vx-col w-full">
                      <vs-input
                        class="w-full"
                        type="password"
                        label="Password"
                        v-model="input.password"
                        v-on:keyup.enter="handleSubmit()"
                      />
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col w-full">
                      <vs-button @click="handleSubmit()" class="mr-3 mb-2"
                        >Submit</vs-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      input: {
        username: null,
        password: null,
      },
      isWrong: false,
      isLoading: false,
    };
  },
  methods: {
    async handleSubmit() {
      this.isWrong = false;
      this.$vs.loading();
      try {
        await this.$sanctum.loginWithUsername(this.input);
        if (this.$sanctum.isAuth()) {
          this.$router.push({ name: "dashboard" });
          window.location.reload();
        } else {
          this.isWrong = true;
        }
        this.$vs.loading.close();
      } catch (error) {
        alert("WRONG");
        this.$vs.loading.close();
      }
    },
  },
  watch: {
    input: {
      deep: true,
      handler: function () {
        this.isWrong = false;
      },
    },
  },
};
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
</style>
